// SurferMonkeyWidget.js
import React from 'react';
import '../Styles/SurferMonkeyWidget.css';

const SurferMonkeyWidget = ({ userMessage, onClose }) => {
    const iframeRef = React.useRef(null);

    const handleIframeLoad = () => {
        console.log("User intent: ", userMessage)
        const messageToSend = {
            type: 'SurferMonkeyIntent_a4REBKpy4d2kkdxivbaoPirjTnNj3Z',
            data: userMessage
        };
        if (iframeRef.current) {
            iframeRef.current.contentWindow.postMessage(messageToSend, "https://surfermonkey.github.io/surfermonkey.widget.v1.github.io/");
        }
    };

    return (
        <div className="modal-container">
            <button className='close-button-iframe' onClick={onClose}>X</button>
            <iframe
                ref={iframeRef}
                onLoad={handleIframeLoad}
                src="https://surfermonkey.github.io/surfermonkey.widget.v1.github.io/"
                frameBorder="0"
                title="SurferMonkey Widget"
                allowFullScreen
            ></iframe>
        </div>
    );
}


export default SurferMonkeyWidget;
